import { paymentPartnersApiTemplateSlice as api } from '../state/paymentPartners/paymentPartnersApiTemplateSlice';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAvailableChargeAndGoCardsV2: build.query<
      GetAvailableChargeAndGoCardsV2ApiResponse,
      GetAvailableChargeAndGoCardsV2ApiArg
    >({
      query: () => ({
        url: `/v2/payment-partners/MAN_CHARGE_AND_GO_PAYMENT/available-cards`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetAvailableChargeAndGoCardsV2ApiResponse =
  /** status 200 OK */ ChargeAndGoPaymentMethodList;
export type GetAvailableChargeAndGoCardsV2ApiArg = void;
export type ChargeAndGoPaymentMethod = {
  referenceId: string;
  enabled: boolean;
  cardNumber: string;
  alias?: string;
};
export type ChargeAndGoPaymentMethodList = {
  items: ChargeAndGoPaymentMethod[];
};
export const { useGetAvailableChargeAndGoCardsV2Query } = injectedRtkApi;
